module.exports = __webpack_public_path__ + "static/media/sn-2000bt.156c5147.jpg";